<p-button class="prime-button" [styleClass]="classes()" [label]="label()" [type]="type()" [disabled]="disabled()" [raised]="raised()" [rounded]="rounded()" [text]="text()" [outlined]="outlined()" [icon]="icon()" [severity]="severity()" />
